module.exports = __webpack_public_path__ + "static/media/project-dashboard2.ae7f571f.png";